export default __webpack_public_path__ + "img/InterDisplay-Bold_3b6acf3.woff2";